import SummaryInfoTab from './SummaryInfoTab.vue';

export default SummaryInfoTab;
